export default "__VITE_ASSET__CS7O_pV9__"